<script setup lang="ts">
defineProps<{ icon: unknown }>()
</script>
<template>
  <component :is="icon" />
</template>
